<!-- 柱状图 -->
<template>
    <div class="coloRback">
        <el-button type="primary" @click="handleClick()" style="margin-top:10px;">添加</el-button>
        <el-table :data="Backcolor" style="width: 90%" header-align="center" class="coloRtable">
            <el-table-column label="颜色"  align="center" width="100px" >
                <template #default="scope">
                    <!-- {{scope.row}} -->
                  <div :style="{background:scope.row}" class="backgrgba"></div>
                </template>
            </el-table-column>
            <el-table-column label="编辑"  align="center" width="100px">
            <template #default="scope" >
                <el-button link type="primary" size="small" @click="handleClick(scope.$index,true)">
                编辑
                </el-button>
            </template>
            </el-table-column>
            <el-table-column label="删除"   align="center" >
            <template #default="scope">
                <el-button link type="primary" size="small" @click="del(scope.$index)">删除</el-button>
            </template>
            </el-table-column>
         </el-table>
         <!-- 修改 -->
         <el-dialog
            v-model="dialogVisible" 
            title="添加/修改"
            width="500"
            :before-close="handleClose"
        >
            <div class = 'row'>
                <p class = 'title'>颜色</p>
                <p class = 'setvalue'>
                <el-input
                    v-model="modificationColor"
                    style="max-width: 600px"
                    placeholder=""
                >
                <template #append><el-color-picker  v-model="modificationColor"  /> </template>
                </el-input>
                </p>
            </div>
            <template #footer>
            <div class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="determine">
                 确定
                </el-button>
            </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { getCurrentInstance,ref,onMounted,onUnmounted,watch,shallowRef,computed } from "vue";
import * as echarts from 'echarts';
import { useStore } from 'vuex';
import { colorCustomMerge, cloneDeep  } from '../../../utils'// 
import { ElMessage, ElMessageBox } from 'element-plus'
// import sj from './components/json/sj.json'
export default {
    props: {
        Backcolor: {
            type: Array,
            default: function () { return {} }
        },
        // yearRef:{
        //     type: String,
        //     default: function () { return "2024" }
        // }
    },
    setup(props,ctx) {
        const { proxy } = getCurrentInstance();
        const option = ref({})
        const barChartRef = shallowRef(null);
        const chartInstance = shallowRef(null);
       
        const store = useStore();

        const Backcolor=ref(props.Backcolor)

        const selectIndex1=ref(null)
        const dialogVisible= ref(false)
        const modificationColor=ref('')
        const  handleClick=((index,type)=>{
            modificationColor.value=''
            if(type){
                selectIndex1.value=index
                modificationColor.value=Backcolor.value[index]
            }
            
             dialogVisible.value=true
        })
        //确定
        const  determine=(()=>{
            if(selectIndex1.value!=null){
                Backcolor.value[selectIndex1.value]=modificationColor.value
            } else{
                Backcolor.value.push(modificationColor.value)
            }
             dialogVisible.value=false
             ctx.emit('colorChange',Backcolor.value)
        })
        // 删除
        const  del=((index)=>{
            ElMessageBox.confirm(
            '是否删除该色块?',
            '删除颜色',
            {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            draggable: true,
            }
        )
            .then(() => {
                ElMessage({
                    type: 'success',
                    message: '删除成功',
                })
                Backcolor.value.splice(index,1)
                ctx.emit('colorChange',Backcolor.value)
            })
            .catch(() => {
            })
        })
        // 取消
        const  cancel=(()=>{
            selectIndex1.value=''
            modificationColor.value=''  
            dialogVisible.value=false
        })
        return{
            option,
            barChartRef,
            Backcolor,
            handleClick,
            selectIndex1,
            dialogVisible,
            modificationColor,
            determine,
            cancel,
            del
        }
    }
}
</script>

<style scoped lang="less">
.coloRback{
    background: #000;
}
 .coloRback .row{
    display: flex;
    align-items: center;
    height:50px;

    // background:#000;
    .title{
      width:100px;
      height:30px;
      line-height:30px;
      text-align: left;
      color:#000;
    }
    .setvalue{
      flex:1;
      padding-right:20px;
      box-sizing: border-box;
      .el-input{
        background:pink!important;
      }
      
    }
  }
 :deep(.el-table__cell){
    background: #000 !important;
  }
  :deep(.is-leaf) {
    border: none !important;
  }
  :deep(td) {
    border: none !important;
  }
  :deep(.el-table__inner-wrapper::before){
    background-color:#000;
  }
.chart {
    width: 100%;
    height: 100vh;
}
.coloRback {
  margin-left: 25px;
}
.backgrgba {
    width: 20px;
    height: 20px;
    border-radius:5px ;

}
.coloRtable :deep(.cell)  {
    display: flex ;
    justify-content: center ;
    align-items: center ;
}

</style>